import React, { ChangeEvent } from "react";
import { MenuItem, TextField } from "@mui/material";
import customSelectStyle from "./customSelectStyle";

interface Option {
  label: string;
  value: string;
}

interface CustomSelectProps {
  maxWidth?: string;
  label: string;
  name: string;
  value: string;
  onChange: (e: ChangeEvent<{ name?: string; value: unknown }>) => void;
  disabled?: boolean;
  options: Option[];
}

const CustomSelect: React.FC<CustomSelectProps> = ({ maxWidth = "100%", label, name, value, onChange, disabled, options }) => {
  return (
    <TextField
      select
      fullWidth
      sx={{ maxWidth, ...customSelectStyle.textField }}
      margin="normal"
      label={label}
      name={name}
      value={value}
      onChange={(e) => onChange(e as ChangeEvent<HTMLInputElement>)}
      disabled={disabled}
      variant="outlined"
    >
      {options.map((option) => (
        <MenuItem sx={customSelectStyle.menuItem} key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default CustomSelect;
